export default "/assets/wide.svg"